export function isNotNull(value) {
    return value !== null;
}
//# sourceMappingURL=predicates.js.map